import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Row, Col, Drawer, Space, TreeSelect, Alert } from 'antd';
import { isMobile } from 'react-device-detect';
import { updateAssignment } from '../../redux/actions/CommissionRevenue';
import { makeTree } from '../../utils/helpers';

class AssignmentsServiceForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            errorMsg: null
        };
    }

    async handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({ isLoading: true });
                    values.type = 'service';
                    await this.props.updateAssignment(this.props.currentItem.id, values);
                    this.onClose();

                    this.props.loadData()
                    this.setState({ isLoading: false });
                } catch (error) {
                    if (error.response && error.response.data) {
                        // Chuyển lỗi thành JSX để hỗ trợ HTML
                        const errorMsgJSX = (
                            <span dangerouslySetInnerHTML={{ __html: error.response.data.msg }} />
                        );
                        this.setState({ errorMsg: errorMsgJSX });
                    } else {
                        this.setState({ errorMsg: <span>Đã xảy ra lỗi, vui lòng thử lại!</span> });
                    }
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onClose() {
        this.setState({ errorMsg: null });
        this.props.onCancel();
        this.props.form.resetFields();
    }

    onSetMessage = () => {
        this.setState({ errorMsg: null });
    };

    render() {
        const { isLoading, errorMsg } = this.state;
        var { visible, currentItem, service_active_list } = this.props;
        const { getFieldDecorator } = this.props.form;

        const services = makeTree(service_active_list || [], 0);

        return (
            <Drawer
                visible={visible}
                title="Cập nhật dịch vụ áp dụng"
                onOk={(e) => this.handleSubmit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '70%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.handleSubmit(e)}
                            >
                                Cập nhật
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        {errorMsg && (
                            <Alert
                                message={errorMsg}
                                type='error'
                                showIcon
                                className="mb-2 mt-2"
                                closable
                                onClose={() => this.onSetMessage(null, null)}
                            />
                        )}
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item
                                    label="Dịch vụ áp dụng"
                                >
                                    {getFieldDecorator('service_ids', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng chọn!',
                                            },
                                        ],
                                        initialValue: currentItem?.service_ids ?? []
                                    })(
                                        <TreeSelect
                                            showSearch
                                            style={{ width: '100%' }}
                                            dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                            treeData={services || []}
                                            treeNodeFilterProp='title'
                                            allowClear
                                            placeholder="Chọn một bản ghi"
                                            treeDefaultExpandAll
                                            multiple
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null
                }
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        service_active_list: state.ServiceReducer.service_active_list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateAssignment: (id, data) => dispatch(updateAssignment(id, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AssignmentsServiceForm' })(AssignmentsServiceForm));
